// OrdersList.jsx
import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";
import { Card, ListGroup, Badge, Button } from "react-bootstrap";
import carImage from "../../../assets/car2.jpg";
import icon from "../../../assets/no-book-icon.png";
import downloadIcon from "../../../assets/booking-download-icon.png";
import { Link } from "react-router-dom";

const HomeOrderListCard = ({ dashboardListings }) => {
  const handleDownloadVoucherPDF = (pdfLinkURL, id) => {
    // Create a link element for downloading the PDF
    const pdfLink = document.createElement("a");
    pdfLink.href = pdfLinkURL; // Set the href to the PDF link
    pdfLink.target = "_blank"; // Open the PDF in a new tab
    pdfLink.download = `voucher_${id}.pdf`; // Set the desired file name for download
    document.body.appendChild(pdfLink);
    pdfLink.click(); // Trigger download
    document.body.removeChild(pdfLink);
  };

  return (
    <Card className="dod-dash-main-page-orders-list">
      <Card.Body>
        <h4>Recent Orders</h4>
        <ListGroup variant="flush">
          {dashboardListings?.products?.latestOrders?.map((order, index) => (
            <ListGroup.Item
              key={index}
              className="dod-dash-main-page-order-item d-flex justify-content-between align-items-center"
            >
              <div
                style={{
                  minWidth: "35%",
                }}
                className="dod-dash-main-page-order-info"
              >
                <img
                  src={
                    order?.product?.product_cover_image
                      ? order?.product?.product_cover_image
                          ?.product_image_filename
                      : carImage
                  }
                  alt={order?.product?.product_title}
                  className="dod-dash-main-page-order-img"
                />
                <div className="">
                  <p className="m-0 p-0 dod-dash-main-page-order-booking-id">
                    {order?.voucher_number}
                  </p>
                  <h5 className="m-0 p-0  home-list-text-title">
                    {order?.product?.product_title}
                  </h5>
                </div>
              </div>
              <div>
                <p className="m-0 p-0 dod-dash-main-page-order-price">
                  {order?.order_line_items[0]?.total_price
                    ? `AED ${parseInt(order?.order_line_items[0]?.total_price)}`
                    : ""}
                </p>
              </div>
              <div className="dod-dash-main-page-order-meta d-flex align-items-center justify-content-end gap-2">
                <p className="m-0 p-0 d-flex align-item-center">
                  <Icon
                    icon="uil:calender"
                    color="#EB662B"
                    fontSize={20}
                    className="me-1"
                  />
                  {order?.trip_date}
                </p>
              </div>
              <div className="d-flex align-items-center gap-3">
                <button
                  onClick={() =>
                    handleDownloadVoucherPDF(
                      order?.voucher_path,
                      order?.voucher_number
                    )
                  }
                  className="fp-bc-booking-download-button"
                >
                  <img
                    src={downloadIcon}
                    alt="download icon"
                    className="m-0 p-0"
                    width={20}
                    height={20}
                  />
                </button>

                <Link
                  className="m-0 fp-bc-booking-id-link-view-details "
                  to={`/bookings/${order?.voucher_number}`}
                >
                  View details
                </Link>
              </div>
            </ListGroup.Item>
          ))}
        </ListGroup>
        {dashboardListings?.products?.latestOrders?.length === 0 && (
          <div className="d-flex align-items-center justify-content-center bg-white rounded-md  py-3">
            <div className=" py-5">
              <div className="d-flex align-items-center justify-content-center"></div>
              <img className="mb-3 no-booking-img" src={icon} alt="empty" />
              <p className="m-0 cp-label text-center">
                No recent order avaliable!
              </p>
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default HomeOrderListCard;
